import React from "react";
import './App.css';

const Landing = () => {
    return (
        <section className="App-header" id="landing">
        <p className="Description"> Los Angeles Crime Count Predictor <br /> 
        Using Linear Regression </p>
        <button className="BtnStart">
          <code> <a 
          href="#mainsection"
          rel="noopener noreferrer"
          > Run Predictor </a></code>
        </button>
      </section>
    )
}

export default Landing;